import { SystemStyleObject } from '@chakra-ui/react'

import { tokenVar } from '../../theme/tokenVar'
import type { ColorScheme } from '../../types'

export type { ColorScheme }

const lightTokens = {
  defaultBg: 'light.bg.card-elevated',
  hoverBg: 'light.bg.tab-active',
  selectedBg: 'light.bg.card',
  focusRing: 'light.interactive.focus-ring',
  borderColor: 'light.border.subtle',
  defaultIconColor: tokenVar('colors.light.icon.secondary'),
  hoverIconColor: tokenVar('colors.light.icon.primary'),
  selectedIconColor: tokenVar('colors.light.icon.active'),
  disabledIconColor: tokenVar('colors.light.icon.disabled'),
}

const darkTokens = {
  defaultBg: 'bg.card-elevated',
  hoverBg: 'bg.tab-active',
  selectedBg: 'bg.card',
  focusRing: 'interactive.focus-ring',
  borderColor: 'border.subtle',
  defaultIconColor: tokenVar('colors.icon.secondary'),
  hoverIconColor: tokenVar('colors.icon.primary'),
  selectedIconColor: tokenVar('colors.icon.active'),
  disabledIconColor: tokenVar('colors.icon.disabled'),
}

export const getUtilityIconColor = (
  isSelected: boolean,
  isActive: boolean,
  colorScheme: ColorScheme = 'dark',
  disabled = false
): string => {
  const t = colorScheme === 'light' ? lightTokens : darkTokens
  if (disabled) return t.disabledIconColor
  if (isSelected) return t.selectedIconColor
  if (isActive) return t.hoverIconColor
  return t.defaultIconColor
}

export const UTILITY_BUTTON_SIZE = {
  width: '56px',
  height: '40px',
} as const

export const utilityButtonStyles = (
  isSelected: boolean,
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => {
  const t = colorScheme === 'light' ? lightTokens : darkTokens
  const bg = isSelected ? t.selectedBg : t.defaultBg
  const hoverBg = isSelected ? t.selectedBg : t.hoverBg
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...UTILITY_BUTTON_SIZE,
    p: '0',
    border: '1px solid',
    borderColor: t.borderColor,
    borderRadius: '0',
    bg,
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background 0.15s ease',
    _hover: { bg: hoverBg },
    _active: { bg: hoverBg },
    _disabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
      _hover: { bg },
    },
    _focusVisible: {
      outline: '2px solid',
      outlineColor: t.focusRing,
      outlineOffset: '2px',
    },
  }
}
